<template>
    <div class="home pure-g">
        
        <MainMenu class="pure-u-1-6"/>

        <div class="pure-u-5-6">
    
            <div class="menuBarBox">
                <div class="pure-menu pure-menu-horizontal menuBar">
                    <li id="menuCancel" class="pure-menu-item"><router-link class="pure-menu-link" to="/accounts" >Abbrechen</router-link></li>
                    <li id="menuSave" class="pure-menu-item"><a v-on:click="saveAndReturn" class="pure-menu-link" >Speichern</a></li>
                </div>
            </div>
    
            <div class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Benutzer editieren</legend>

                        <div class="pure-g">
                            <div class="pure-u-1-1">
                                <label for="account">Anmeldename</label>
                                <input id="account" class="pure-u-10-24" type="text" v-model="name">
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="email">E-Mail</label>
                                <input id="email" class="pure-u-10-24" type="email" v-model="email">
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="language">Sprache</label>
                                <select id="language" v-model="language" class="mb-3">
                                    <option value="de">Deutsch</option>
                                    <option value="en">Englisch</option>
                                </select>
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="password-1">Passwort</label>
                                <input id="password-1" class="pure-u-7-24" type="password" v-model="password">
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="password-2">Passwort wiederholen</label>
                                <input id="password-2" class="pure-u-7-24" type="password" v-model="passwordCheck">
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="comment">Bemerkungen</label>
                                <textarea id="comment" class="pure-u-10-24 comment" v-model="comment">

                                </textarea>
                            </div>
                        </div>

                        <Role-editor :accountRoles="roles"/>
                    </fieldset>
                </form>

            </div>        
        </div> 
    </div>
</template>

<script>
import MainMenu from '@/components/MainMenu.vue'
import axios from "axios"
import router from '@/router.js'
import { getJwt } from '@/utils/auth.js'
import { toastInfo, toastError } from '@/utils/toast.js'
import RoleEditor from '@/components/RoleEditor.vue'


export default {
  name: 'editAccountView',
  data: function () {
      return {
        name: null,
        email: null,
        comment: null,
        password: null,
        passwordCheck: null,
        language: 'de',
        roles: [],
        languages: [
            { value: 'de', text: 'German' },
            { value: 'en', text: 'English' }
        ]
      }
  },
  components: {
    MainMenu,
    RoleEditor
  },
  mounted: function() {
    
    this.loadData(this.$route.params.url)
  },
  methods: {

    loadData: function(url) {

      axios(
        { 
            method: 'GET', 
            'url': url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getJwt()
            }
        })
        .then(
            result => {                
                console.log(result.data)

                this.name = result.data.name
                this.email = result.data.email
                this.language = result.data.language
                this.comment = result.data.comment
                this.roles = result.data.roles
            },
            error => {
                console.error(error.response.data.status)
            }
      )
    },

    save: function(doReturn) {

        if (this.password !== this.passwordCheck) {

            toastError('Die Passwörter stimmen nicht überein!')
            return
        }

        axios({ 
            method: 'PUT', 
            'url': this.$route.params.url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getJwt()
            },
            data: {
                name: this.name,
                password: this.password,
                language: this.language,
                email: this.email,
                comment: this.comment,
                roles: this.roles
            }
        })
        .then(
            result => {
                toastInfo('Der Benutzer wurde aktualisiert.')

                if (doReturn) {
                    router.push({ name: 'accountView' })
                } else {
                    this.clear()
                }
            },
            error => {
                toastError(error.response.data.message)
            }
        )
    },
    saveAndReturn: function() {

        this.save(true)  
    }
  }
}
</script>

<style>


#language {
    width: 200px;
}



</style>